enum BeeswaxSegmentUserCountRegion {
  APAC = 'APAC',
  NAM = 'NAM',
  EMEA = 'EMEA',
}

export default BeeswaxSegmentUserCountRegion;
